import { Badge, Button, Spinner } from 'reactstrap';
import DownloadButton from '../../components/DownloadButton';
import { MapListDataProps } from '../../interfaces';
import { formatDateUSWithMoment } from '../../utils/commonFn';
import { ADMIN_IMPORT_SOURCE, FAILED_IMPORT, IMPORT_SOURCE } from '../../utils/constant';
import { getCSVImportsStatusColor } from '../../utils/helper';
import EMAIL_ICON from '../../assets/images/email-icon.svg';
import { useMutation } from '@apollo/client';
import { RETRY_DATA_CSV_IMPORTS } from './gql';
import { toast } from 'react-toastify';
import REFRESH_ICON from '../../assets/images/refresh-icon.png';

const RetryButton = ({ id, status, refetch }) => {
    const [retryDataCsvImport, { loading: retryLoader }] = useMutation(RETRY_DATA_CSV_IMPORTS)
    const retryAction = async (id: string) => {
      try {
        const response = await retryDataCsvImport({ variables: { id } })
        if (response?.data?.retryDataCsvImport?.status === 201) {
          toast.success("Import has been re-started!")
        }
        refetch()
      } catch {
        toast.error("Unable to retry")
      }
    }
    return (
      <Button className="bg-transparent border-0 p-0 mr-3 fade-button"
        disabled={status !== FAILED_IMPORT}
      >
        {
          retryLoader ?
            <Spinner size="sm" style={{ color: "#eaa827" }} className="m-0" /> :
            <img className="m-0" src={REFRESH_ICON}
              onClick={async () => {
                await retryAction(id)
              }} alt="retry" />}
      </Button>
    )
}

export const mapListData = ({
  data: {
    id,
    fileName,
    user: { firstName, lastName },
    jobStartedAt,
    status,
    fileUrl,
    jobResponse,
    totalCSVRows,
    totalEmailsSent,
    sourceType,
  },
  adminImport,
  isContactImport,
  setErrorMessage,
  setIsOpenErrorModal,
  setShowEmailModal,
  setSelectedFileId,
  refetch,
}: MapListDataProps) => {
  return (
    <>
      <td>{fileName}</td>

      {!isContactImport && <td>{[...IMPORT_SOURCE, ...ADMIN_IMPORT_SOURCE].find(({ value }) => value === sourceType)?.label}</td>}

      <td>{`${firstName} ${lastName}`}</td>
      <td>{formatDateUSWithMoment(jobStartedAt)}</td>
      {!adminImport && <td>{totalCSVRows || '--'}</td>}
      {!adminImport && isContactImport && <td>{totalEmailsSent}</td>}

      <td className="badge-pading">
        <button
          className="bg-transparent border-0 p-0 mr-3"
          disabled={status !== FAILED_IMPORT}
          onClick={() => {
            if (status === FAILED_IMPORT) {
              setErrorMessage(jobResponse!);
              setIsOpenErrorModal(true);
            }
          }}
        >
          <Badge color={getCSVImportsStatusColor(status)} className="text-capitalize">
            {status}
          </Badge>
        </button>
      </td>

      <td>
        {!adminImport && !isContactImport && <RetryButton id={id} status={status} refetch={refetch} />}

        <DownloadButton url={fileUrl} fileType={isContactImport ? "xlsx" : "csv"} nickName={isContactImport ? fileName?.split(".xlsx")[0] : fileName?.split(".csv")[0]} />
        
        {isContactImport && <Button
            onClick={() => {
              setSelectedFileId?.(id);
              setShowEmailModal?.(true);
            }}
            className="btn bg-transparent p-0 border-0"
            >
            <img src={EMAIL_ICON} alt="email" width="18px" />
            </Button>
        }
      </td>
    </>
  );
};